import {
  REPORT_GET_HTML,
  REPORT_SET_CURRENT,
  REPORT_FULFILL_REQUIREMENT,
  REPORT_SEND_ERROR_REPORT,
  REPORT_PDF_DOWNLOAD,
  REPORT_REQUEST,
  REPORT_SUCCESS,
  REPORT_ERROR
} from "@/store/types"

import axios from "@/store/axios"
import { saveAs } from "file-saver"

const state = {
  report: null,
  html: null,
  isLoading: false,
  error: null
}

const getters = {
  getCurrentReport: (state) => state.report,
  getCurrentReportHTML: (state) => state.html,
  isReportLoading: (state) => state.isLoading,
  getReportError: (state) => state.error
}

const actions = {
  [REPORT_GET_HTML]: ({ state, commit }) => {
    return new Promise((resolve, reject) => {
      commit(REPORT_REQUEST)

      axios
        .get(state.report.html_url)
        .then((resp) => {
          // if (process.env.NODE_ENV === "development") {
          //   console.log(resp)
          // }

          commit(REPORT_SUCCESS, { html: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(REPORT_ERROR, err)
          reject(err)
        })
    })
  },
  [REPORT_PDF_DOWNLOAD]: ({ commit }, { id, type, save = true }) => {
    return new Promise((resolve, reject) => {
      commit(REPORT_REQUEST)

      axios
        .get(`/api/v3/reports/${id}/pdf/`, { responseType: "blob" })
        .then((resp) => {
          if (save) {
            saveAs(resp.data, `${type}_report__${id}.pdf`)
          }

          commit(REPORT_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(REPORT_ERROR, err)
          reject(err)
        })
    })
  },
  [REPORT_FULFILL_REQUIREMENT]: ({ state, commit }, { action, detail } = {}) => {
    return new Promise((resolve, reject) => {
      commit(REPORT_REQUEST)

      axios
        .post(`/api/v3/reports/${state.report.id}/fulfill_requirement/`, {
          action,
          detail
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(REPORT_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(REPORT_ERROR, err)
          reject(err)
        })
    })
  },
  [REPORT_SEND_ERROR_REPORT]: ({ state, commit }, { message }) => {
    return new Promise((resolve, reject) => {
      commit(REPORT_REQUEST)

      axios
        .post(`/api/v3/reports/${state.report.id}/send_error_report/`, {
          email_content: message
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(REPORT_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(REPORT_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [REPORT_SET_CURRENT]: (state, report) => {
    state.report = report
    state.html = null
  },
  [REPORT_REQUEST]: (state) => {
    state.isLoading = true
  },
  [REPORT_SUCCESS]: (state, { html, current } = {}) => {
    state.isLoading = false
    state.error = null

    if (html) {
      state.html = html
    }
    if (current) {
      state.report = current
    }
  },
  [REPORT_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err.response.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
